<div class="workspace-failure-banner" role="alert">
  <div class="workspace-failure-banner__icon">
    <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
  </div>
  <div class="workspace-failure-banner__text">
    <span class="workspace-failure-banner__title">{{ bannerTitle }}</span>
    <span *ngIf="failedStep" class="workspace-failure-banner__step">Failed at: {{ failedStep }}</span>
    <span *ngIf="failedReason" class="workspace-failure-banner__reason">{{ failedReason }}</span>
  </div>
  <div *ngIf="canRetry" class="workspace-failure-banner__actions">
    <button type="button" class="workspace-failure-banner__retry" [disabled]="isRetrying" (click)="retry()">
      {{ retryLabel }}
    </button>
  </div>
</div>
